import { useContext } from 'react'

import { Box } from '@material-ui/core'

import { DelayedRender, StepsContext, StepsStatus } from 'UI/Components'
import { Step } from './Step'

import { PlaybookType } from 'app/types'
import {
    useAnonymAuth,
    useAuth,
    useBrandKit,
    usePublicBrandKit,
    useRoles,
    useWindowView
} from 'hooks'

type Props = {
    playbook: PlaybookType
}

export const Steps = ({ playbook }: Props) => {
    const { steps } = playbook

    const { status, stepsProgress } = useContext(StepsContext)

    const { isMobileView } = useWindowView()

    const { uid } = useAuth()
    const { isContentManager, isAdmin, isSuperAdmin } = useRoles(playbook.uploadedByOrgId)

    const canEdit =
        !isMobileView &&
        (uid === playbook.creator_uid || isContentManager || isAdmin || isSuperAdmin) &&
        // MagicCapture flow is in action, need to wait until it's finished
        [StepsStatus.skipped, StepsStatus.done].includes(status)

    const showMagicAnimation = [StepsStatus.generating, StepsStatus.typing].includes(status)

    const { isAnonymous } = useAnonymAuth()
    const getBrandKit = isAnonymous ? usePublicBrandKit : useBrandKit
    const { brandKitHighlightColor } = getBrandKit(playbook.uploadedByOrgId)

    if (!steps?.length) return null

    return (
        <Box pt={1} m="0 auto" width={isMobileView ? '100%' : '85%'}>
            {steps.map((step, idx) => {
                const firstStep = steps[0]?.kind === 'cover' ? 1 : 0

                return (
                    <DelayedRender delayTime={idx <= 10 ? 0 : Math.ceil(idx / 10) * 1000} key={idx}>
                        <Step
                            index={idx}
                            showGoTo={idx === firstStep}
                            step={step}
                            canEdit={canEdit || stepsProgress[idx] === 100}
                            playbookId={playbook.id}
                            brandKitHighlightColor={brandKitHighlightColor}
                            showMagicAnimation={showMagicAnimation && stepsProgress[idx] !== 100}
                        />
                    </DelayedRender>
                )
            })}
        </Box>
    )
}
